import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

interface SetConsolidatedReviewParams {
	organization_id: string;
	company_id: string;
	report_id: string;
	review_id: string;
	consolidated: boolean;
	locale: string;
	include_fields?: string[];
}

const Service = Resolution886ReportService.getInstance();

export const useConsolidateResolution886Report = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: SetConsolidatedReviewParams) => Service.setConsolidatedReview(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886_REPORT_REVIEW]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_RESOLUTION_886]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886_REVIEW_RESULTS]);

			message.success(I18n.get('Report consolidated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error consolidating report'));
		}
	});
};
